import React from 'react';
import TablePricesContractor from '~/pages/TablePricesContractor';

export default function ContractorPriceTable() {
  return <TablePricesContractor />;
}
